import { render, staticRenderFns } from "./wanzhengview.vue?vue&type=template&id=2313ad48&scoped=true"
import script from "./wanzhengview.vue?vue&type=script&lang=js"
export * from "./wanzhengview.vue?vue&type=script&lang=js"
import style0 from "./wanzhengview.vue?vue&type=style&index=0&id=2313ad48&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2313ad48",
  null
  
)

export default component.exports